// src/auth/LogoutOnLeave.jsx
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { getAuthClient } from "../firebaseConfig";

const PROTECTED_PREFIXES = ["/cashup", "/super"];

export default function LogoutOnLeave() {
  const { pathname } = useLocation();
  const prevPath = useRef(pathname);
  const first = useRef(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Skip first render; we're not "leaving" yet
    if (first.current) {
      first.current = false;
      prevPath.current = pathname;
      return;
    }

    const wasProtected = PROTECTED_PREFIXES.some((p) => prevPath.current.startsWith(p));
    const nowProtected = PROTECTED_PREFIXES.some((p) => pathname.startsWith(p));

    // We only sign out when going from protected → non-protected
    if (wasProtected && !nowProtected) {
      const auth = getAuthClient();
      if (!auth.currentUser) {
        navigate("/login", { replace: true });
        return;
      }
      signOut(auth).finally(() => navigate("/login", { replace: true }));
    }

    prevPath.current = pathname;
  }, [pathname, navigate]);

  return null;
}
